import { Spin } from 'antd'
import { get } from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

import { rehostAssetUrl } from '../../dux/modules/utils'

// ****************
// React Components
// ****************
class AssetPreviewThumbnail extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isLoading: false,
      hasError: false,
    }
  }

  componentDidUpdate(prevProps) {
    const { asset } = this.props
    const assetPreview = get(asset, 'preview', null)
    const prevAssetPreview = get(prevProps, 'asset.preview', null)

    if (assetPreview && assetPreview !== prevAssetPreview) {
      this.setState({ hasError: false, isLoading: true })
    }
  }

  handleOnLoad = () => {
    this.setState({ isLoading: false })
  }

  handleOnError = () => {
    this.setState({ hasError: true, isLoading: false })
  }

  render() {
    const { asset, width, height, imageStyles } = this.props
    const { isLoading, hasError } = this.state

    const assetPreview = rehostAssetUrl(get(asset, 'preview', null))
    const imageSrcSet =
      `${assetPreview}_thumb-200x 200w, ${assetPreview}_thumb-250x 250w, ` +
      `${assetPreview}_thumb-375x 375w, ${assetPreview}_thumb-500x 500w,`
    const renderStaticPreview = !assetPreview || hasError

    const assetIcon = get(asset, 'icon', 'file')
    const backgroundColor = get(asset, 'color', null)

    return (
      <div style={{ ...styles.container, width, height }}>
        {/* Spinner */}
        {isLoading && (
          <div style={{ ...styles.spinnerContainer, width, height }}>
            <Spin />
          </div>
        )}

        {/* Image or Icon */}
        {renderStaticPreview ? (
          <div style={{ ...styles.staticPreviewContainer, backgroundColor }}>
            <i className={`fa ${assetIcon}`} style={styles.staticPreviewIcon} />
          </div>
        ) : (
          <img
            src={assetPreview}
            srcSet={imageSrcSet}
            sizes={
              '(max-width: 767px) 200px, (max-width: 1199px) 250px, (max-width: 2099px) 375px, ' +
              '500px'
            }
            style={{ ...styles.thumbnailImage, ...imageStyles }}
            onLoad={this.handleOnLoad}
            onError={this.handleOnError}
          />
        )}
      </div>
    )
  }
}

// ******
// Styles
// ******
const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  spinnerContainer: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#00000037',
    zIndex: 10,
  },
  thumbnailImage: {
    maxWidth: '100%',
    height: '100%',
    objectFit: 'cover',
    overflow: 'hidden',
    borderRadius: '4px',
    boxShadow: '0 2px 12px 0 rgba(0, 0, 0, 0.17)',
  },
  staticPreviewContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    borderRadius: '4px',
    boxShadow: '0 2px 12px 0 rgba(0, 0, 0, 0.17)',
  },
  staticPreviewIcon: {
    fontSize: '32px',
    color: '#d9d9d9',
  },
}

// *********
// PropTypes
// *********
AssetPreviewThumbnail.propTypes = {
  asset: PropTypes.object,
  height: PropTypes.string,
  width: PropTypes.string,
  imageStyles: PropTypes.object,
}

// *************
// Default Props
// *************
AssetPreviewThumbnail.defaultProps = {
  width: '100px',
  height: '100px',
  imageStyles: {},
}

export default AssetPreviewThumbnail
